import { render } from "./Button.vue?vue&type=template&id=ce8d4750&scoped=true"
import script from "./Button.vue?vue&type=script&lang=ts"
export * from "./Button.vue?vue&type=script&lang=ts"

import "./Button.vue?vue&type=style&index=0&id=ce8d4750&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-ce8d4750"

export default script